import { Toast as PrimeToast } from "primereact/toast";

import type { ToastViewProps } from "./types-toast";

export function ToastView({ toastRef, className, pt, rest }: ToastViewProps) {
  return <PrimeToast ref={toastRef} {...rest} className={className} pt={pt} />;
}
